/**
 * 어드민 세션·로컬 캐시 초기화.
 *
 * 어드민은 dugeun.heart-way.life 서브도메인 단독으로 실행되므로
 * heart-way.life(앱/마케팅)의 localStorage에는 접근할 수 없다.
 * 따라서 여기서는 어드민 자신의 localStorage 키만 정리한다.
 */

const ADMIN_STORAGE_KEYS = [
  'shimjanggil_admin_session',
  'shimjanggil_admin_last_activity',
  'shimjanggil_admin_lockout',
]

const ADMIN_SUPABASE_PATTERN = 'shimjanggil-admin-auth'

function removeKeysByPattern(pattern: string) {
  const keysToRemove: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.includes(pattern)) keysToRemove.push(key)
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}

export function resetAdminData(): void {
  ADMIN_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
  removeKeysByPattern(ADMIN_SUPABASE_PATTERN)
}
